<template>
  <div>
    <div class="dialog-cover" v-if="showDialog">
      <div class="dialog-content">
        <div class="dialog_main">
          <div class="sub-title">长按二维码关注</div>
          <img src="/static/qrcode.jpg">
          <div class="sub-info">{{tipsInfo}}</div>
          <div class="sub-info-bnt" @click="hideSub">我知道了</div>
        </div>
      </div>
    </div>
    <div class="sub-tips" :style="isSubed?'position: relative;':'position: fixed;'">
      <div class="logo-container">
        <div class="empty" @click="goback()"><i class="iconfont icon-back"></i></div>
        <div class="img-center">
          <img src="/static/logo-64x64.png">
        </div>
      </div>
      <div class="sub-bnt-container">
        <div class="sub-bnt" v-if="!isSubed" @click="showSub('')">关 注</div>
      </div>
    </div>
    <div class="creator-info" :style="isSubed?'':'margin-top: 34px;'">
      <div class="header">
        <img :src="header">
      </div>
      <div class="user-info">
        <div class="name">
          {{circle.user.nickname}}
          <i class="iconfont icon-nan2 nan" v-if="circle.user.sex==1"></i>
          <i class="iconfont icon-nv2 nv" v-else></i>
        </div>
        <div class="join">{{subTime}}加入</div>
        <div class="auth">
          <span class="auth-yes" v-if="auth=='已实名认证'">{{auth}}</span>
          <span class="auth-ing" v-else-if="auth=='待实名审核'">{{auth}}</span>
          <span class="auth-no" v-else>{{auth}}</span>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="goods-info">
        <div class="title">{{typeTitle}}：{{level}}{{circle.title}}</div>
        <div
          class="can-use"
          v-if="circle.major"
        >院系：{{circle.major.indexOf("适用")==0?circle.major:"适用"+circle.major}}</div>
        <div
          class="can-use"
          v-if="circle.class"
        >年级：{{circle.class.indexOf("适用")==0?circle.class:"适用"+circle.class}}</div>
        <div class="demand">
          {{demand}}
          <span class="cost" v-if="circle.cost">原价：￥{{circle.cost}}</span>
        </div>
        <div class="sum" v-if="circle.sum >= 0">数量：{{circle.sum}}</div>
      </div>
    </div>
    <div class="tips-content">
      <div class="tips">
        <div class="view">
          <i class="iconfont icon-liulan"></i>
          <span>{{circle.view}}次</span>
        </div>
        <div class="zan">
          <i class="iconfont icon-dianzan"></i>
          <span>{{circle.zan}}次</span>
        </div>
        <div class="time">
          <i class="iconfont icon-shijian"></i>
          <span>{{createTime}}前</span>
        </div>
      </div>
    </div>
    <div class="desc">
      <div v-html="circle.remark"></div>
      <img
        v-for="item in circle.pics"
        :key="item._id"
        :src="item.url"
        style="width: 100%; margin-top: 5px; margin-bottom: 5px;"
      >
    </div>
    <div class="dianzan">
      <div class="quan" @click="zan">
        <i class="iconfont icon-zan"></i>
      </div>
    </div>
    <div class="zan-tips">{{circle.zan==0?"还没有人点赞":circle.zan+"人点赞"}}</div>

    <!-- 底部菜单 -->
    <div class="footer">
      <div class="footer-item enter" @click="gotoHome">进入集市</div>
      <div class="footer-item warn" @click="showComplainPicker">举报投诉</div>
      <div class="footer-item contact" @click="contact">联系TA</div>
    </div>
  </div>
</template>

<script>
const wx = require("weixin-js-sdk");
import weui from "weui.js";
import moment from "moment";
import axios from "axios";
import config from "../../config/config.js";

export default {
  data() {
    return {
      encodeToken: "",
      token: "",
      showDialog: false,
      tipsInfo: '"校圆通"专注校园生活，提供一站式综合服务平台',
      openid: null,
      circle: {
        user: {
          nickname: null
        },
        zan: 0
      },
      typeTitle: null,
      level: null,
      demand: null,
      header: null,
      subTime: null,
      auth: null,
      createTime: null,
      isSubed: false,
      complainPicker: null,
      complains: [
        { text: "诈骗", value: "10" },
        { text: "广告", value: "20" },
        { text: "侵权", value: "30" },
        { text: "色情", value: "40" },
        { text: "其他", value: "0" }
      ]
    };
  },
  created() {
    this.circle._id = this.$route.params.id;
    this.headerBase64 = config.defaultImgBase64;
    this.encodeToken = this.$route.params.token;
    if (this.encodeToken.length > 32) {
      this.isSubed = true;
      this.token = decodeURIComponent(this.encodeToken);
      axios.defaults.headers["Authorization"] = "Bearer " + this.token;

      if (!this.$store.state.User.userInfo._id) {
        axios
          .get("/api/user/wxuserInfo")
          .then(res => {
            if (res.data.success) {
              this.openid = res.data.data.openid;
              this.$store.commit("User/add", res.data.data);
              this.getDetail();
            } else {
              weui.alert("获取用户信息失败");
            }
          })
          .catch(err => {
            weui.alert("获取用户信息失败");
          });
      } else {
        this.openid = this.$store.state.User.userInfo.openid;
        this.getDetail();
      }
    } else {
      // 不是已关注用户
      this.openid = this.encodeToken;
      this.getDetail();
    }
  },
  methods: {
    goback() {
      this.$router.back(-1);
    },
    preventTouchMove(e) {
      e.stopPropagation();
      e.preventDefault();
    },
    showSub(tips) {
      if (tips) {
        this.tipsInfo = this.tipsInfo + "，" + tips + "。";
      } else {
        this.tipsInfo += "。";
      }
      this.showDialog = true;
      document.addEventListener("touchmove", this.preventTouchMove, {
        passive: false
      });
    },
    hideSub() {
      this.showDialog = false;
      this.tipsInfo = '"校圆通"专注校园生活，提供一站式综合服务平台';
      document.removeEventListener("touchmove", this.preventTouchMove, {
        passive: false
      });
    },
    getDetail() {
      axios
        .get("/api/circle/getById/" + this.circle._id, {
          params: { openid: this.openid }
        })
        .then(res => {
          if (res.data.success) {
            this.circle = res.data.data;
            if (this.circle.remark) {
              this.circle.remark = this.circle.remark.replace(/\n/g, "<br/>");
            }

            let du = moment.duration(
              moment() - moment(this.circle.createdAt),
              "ms"
            );
            this.createTime = du.locale("zh-cn").humanize();

            this.header =
              "data:image/png;base64," + this.circle.user.headimgBase64;
            this.subTime = moment(this.circle.user.subscribeTime).format(
              "YYYY年MM月DD日 HH时mm分"
            );
            if (this.circle.user.authStatus == -1) {
              this.auth = "未实名认证";
            } else if (this.circle.user.authStatus == 0) {
              this.auth = "待实名审核";
            } else if (this.circle.user.authStatus == 1) {
              this.auth = "已实名认证";
            }

            if (this.circle.bizType == 10) {
              this.typeTitle = "想买";
            } else if (this.circle.bizType == 20) {
              this.typeTitle = "出售";
            } else if (this.circle.bizType == 30) {
              this.typeTitle = "想租";
            } else if (this.circle.bizType == 40) {
              this.typeTitle = "出租";
            } else if (this.circle.bizType == 50) {
              this.typeTitle = "想借";
            } else if (this.circle.bizType == 60) {
              this.typeTitle = "出借";
            } else if (this.circle.bizType == 70) {
              this.typeTitle = "我能";
            }

            if (this.circle.feeType == 1) {
              this.demand = "单价：" + this.circle.price + " 元";
            } else {
              this.demand = "价格：免费";
              if (this.circle.demand) {
                this.demand =
                  this.demand + "（要求" + this.circle.demand + "）";
              }
            }

            if (this.circle.level == 100) {
              this.level = "全新";
            } else if (this.circle.level == 99) {
              this.level = "99新";
            } else if (this.circle.level == 90) {
              this.level = "9成新";
            } else if (this.circle.level == 80) {
              this.level = "8成新";
            } else if (this.circle.level == 70) {
              this.level = "7成新";
            } else if (this.circle.level == 60) {
              this.level = "6成新";
            } else if (this.circle.level == 50) {
              this.level = "5成新";
            } else if (this.circle.level == 40) {
              this.level = "4成新";
            } else if (this.circle.level == 30) {
              this.level = "3成新";
            } else if (this.circle.level == 20) {
              this.level = "2成新";
            } else if (this.circle.level == 10) {
              this.level = "1成新";
            } else {
              this.level = "";
            }

            /* 初始化微信分享 */
            let shareTitle =
              "本喵" + this.typeTitle + this.level + this.circle.title; // 分享标题
            let shareDesc =
              '本喵分享了最新动态，精彩校园生活尽在"校圆通"，快进来看看TAヾ(≧O≦)〃喵~'; // 分享描述
            let shareLink =
              "http://wx.aixyt.com/#/share/circleDetail/" + this.circle._id;
            let shareLogo = "";

            if (this.circle.bizType == 10) {
              if (this.circle.goodsType == 10) {
                shareLogo = "http://static.aixyt.com/circle-10-10.png";
              } else {
                shareLogo = "http://static.aixyt.com/circle-10.png";
              }
            } else if (this.circle.bizType == 20) {
              if (this.circle.goodsType == 10) {
                shareLogo = "http://static.aixyt.com/circle-20-10.png";
              } else {
                shareLogo = "http://static.aixyt.com/circle-20.png";
              }
            } else if (this.circle.bizType == 30) {
              shareLogo = "http://static.aixyt.com/circle-30.png";
            } else if (this.circle.bizType == 40) {
              shareLogo = "http://static.aixyt.com/circle-40.png";
            } else if (this.circle.bizType == 50) {
              shareLogo = "http://static.aixyt.com/circle-50.png";
            } else if (this.circle.bizType == 60) {
              shareLogo = "http://static.aixyt.com/circle-60.png";
            } else if (this.circle.bizType == 70) {
              shareLogo = "http://static.aixyt.com/circle-70.png";
            }

            let msgShareContent = {
              title: shareTitle, // 分享标题
              desc: shareDesc, // 分享描述
              link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: shareLogo, // 分享图标
              success: () => {
                // 设置成功
              }
            };
            let tlShareContent = {
              title: shareTitle, // 分享标题
              link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
              imgUrl: shareLogo, // 分享图标
              success: () => {
                // 设置成功
              }
            };
            let url = window.location.href;
            let params = {
              url: url
            };
            let jsConfig = {};
            axios
              .get("/api/wx/jsconfig", { params })
              .then(res => {
                jsConfig = res.data.data;
                jsConfig.jsApiList = [
                  "updateAppMessageShareData",
                  "updateTimelineShareData",
                  "onMenuShareAppMessage",
                  "onMenuShareTimeline"
                ];
                wx.config(jsConfig);
              })
              .catch(err => {
                console.log(err);
              });

            wx.ready(function() {
              wx.updateAppMessageShareData(msgShareContent);
              wx.updateTimelineShareData(tlShareContent);
              wx.onMenuShareAppMessage(msgShareContent);
              wx.onMenuShareTimeline(tlShareContent);
            });

            /* 微信分享初始结束 */
          } else {
            weui.alert(res.data.message);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    zan() {
      axios
        .put("/api/circle/active/" + this.circle._id, { bizType: 10, type: 20, openid: this.openid })
        .then(res => {
          if (res.data.data == 0) {
            weui.toast("您已赞过", 500);
          } else {
            this.circle.zan++;
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    gotoHome() {
      if (this.isSubed) {
        window.location.href =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa5520eff0ecff405&redirect_uri=http%3A%2F%2Fwx.aixyt.com%2Fapi%2Fwx%2Fauth&response_type=code&scope=snsapi_userinfo&state=home#wechat_redirect";
      } else {
        this.showSub("关注公众号并绑定网点后才能进入集市");
      }
    },
    showComplainPicker() {
      if (!this.complainPicker) {
        this.complainPicker = this.$createPicker({
          title: "举报投诉",
          data: [this.complains],
          onSelect: this.selectComplainHandle
        });
      }
      this.complainPicker.show();
    },
    selectComplainHandle(selectedVal, selectedIndex, selectedText) {
      let complain = selectedText[0];
      axios
        .get("/api/circle/complain/" + this.circle._id, {
          params: { openid: this.openid, complain: complain }
        })
        .then(res => {
          if (res.data.success) {
            weui.toast("已提交");
          } else {
            weui.alert("提交失败，请联系平台客服");
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    contact() {
      if (this.isSubed) {
        axios
          .get("/api/circle/contact/" + this.circle._id, {
            params: { openid: this.openid }
          })
          .then(res => {
            if (res.data.success) {
              weui.alert(
                'TA的联系方式已经通过"校圆通"公众号发给您，请注意查收'
              );
            } else {
              weui.alert("获取联系方式失败，请联系平台客服");
            }
          })
          .catch(err => {
            console.log(err);
          });
      } else {
        this.showSub("关注公众号并绑定网点后才能获取TA的联系方式");
      }
    }
  },
  beforeDestroy() {
    /* 重置微信分享 */
    let shareTitle =
      '本喵分享了最新动态，精彩校园生活尽在"校圆通"，快进来看看TAヾ(≧O≦)〃喵~'; // 分享标题
    let shareDesc = "专注校园生活，打造校园一站式综合服务平台。"; // 分享描述
    let shareLink = "http://wx.aixyt.com/#/share/home/-1";
    let shareLogo = "http://static.aixyt.com/logo.png";

    let msgShareContent = {
      title: shareTitle, // 分享标题
      desc: shareDesc, // 分享描述
      link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: shareLogo, // 分享图标
      success: () => {
        // 设置成功
      }
    };
    let tlShareContent = {
      title: shareTitle, // 分享标题
      link: shareLink, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      imgUrl: shareLogo, // 分享图标
      success: () => {
        // 设置成功
      }
    };
    let url = window.location.href;
    let params = {
      url: url
    };
    let jsConfig = {};
    axios
      .get("/api/wx/jsconfig", { params })
      .then(res => {
        jsConfig = res.data.data;
        jsConfig.jsApiList = [
          "updateAppMessageShareData",
          "updateTimelineShareData",
          "onMenuShareAppMessage",
          "onMenuShareTimeline"
        ];
        wx.config(jsConfig);
      })
      .catch(err => {
        console.log(err);
      });

    wx.ready(function() {
      wx.updateAppMessageShareData(msgShareContent);
      wx.updateTimelineShareData(tlShareContent);
      wx.onMenuShareAppMessage(msgShareContent);
      wx.onMenuShareTimeline(tlShareContent);
    });
    /* 重置微信分享结束 */
  }
};
</script>

<style scoped>
.dialog-cover {
  background: rgba(0, 0, 0, 0.7);
  position: fixed;
  z-index: 200;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.dialog-content {
  position: fixed;
  top: 15%;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 300;
}
.dialog_main {
  width: 280px;
  text-align: center;
  background-color: #ffffff;
  border-radius: 15px;
}
.dialog_main img {
  width: 180px;
}
.sub-title {
  font-size: 24px;
  margin-top: 20px;
  margin-bottom: 5px;
  color: #fda800;
}
.sub-info {
  margin: 10px 15px;
  text-align: center;
  font-size: 16px;
}
.sub-info-bnt {
  border-top: 1px solid #fda800;
  font-size: 18px;
  margin-top: 15px;
  margin-bottom: 15px;
  padding-top: 10px;
  color: #fda800;
}
.sub-tips {
  width: 100%;
  top: 0px;
  background-color: #ffffff;
  border-bottom: 1px solid #fda800;
  display: flex;
  z-index: 1000;
}
.logo-container {
  margin-top: 4px;
  margin-bottom: 4px;
  flex: 1;
  text-align: center;
  display: flex;
}
.logo-container .empty {
  width: 60px;
  text-align: left;
  margin-left: 10px;
}
.empty i {
  color: #fda800;
  font-size: 22px;
}
.logo-container .img-center {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-center img {
  height: 22px;
}
.sub-bnt-container {
  width: 60px;
  margin: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.sub-bnt {
  width: 60px;
  height: 26px;
  background-color: #ff0000;
  border-radius: 5px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.creator-info {
  background-color: #fda800;
  height: 120px;
  display: flex;
}
.header {
  width: 120px;
}
.header img {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: 2px solid #ffffff;
  margin-left: 20px;
  margin-top: 20px;
}
.user-info {
  margin-top: 24px;
  color: #ffffff;
}
.name {
  font-size: 18px;
}
.nan {
  color: #296aed;
  font-weight: bold;
}
.nv {
  color: #ec73bb;
  font-weight: bold;
}
.join {
  font-size: 14px;
}
.auth {
  font-size: 12px;
  margin-top: 5px;
}
.auth-no {
  padding: 2px 6px;
  color: red;
  background-color: #ffffff;
}
.auth-ing {
  padding: 2px 6px;
  background-color: #ffffff;
  color: #fda800;
}
.auth-yes {
  padding: 2px 6px;
  background-color: #ffffff;
  color: #3eb94e;
}
.content {
  border-bottom: 1px solid #bdccd4;
}
.goods-info {
  margin: 10px;
}
.title {
  font-size: 16px;
}
.can-use {
  font-size: 16px;
}
.demand {
  font-size: 16px;
}
.cost {
  font-size: 12px;
  text-decoration: line-through;
  margin-left: 15px;
  color: #6b6e77;
}
.sum {
  font-size: 16px;
}
.tips-content {
  border-bottom: 1px solid #bdccd4;
}
.tips {
  display: flex;
  margin: 4px 10px;
  font-size: 14px;
}
.view {
  width: 100px;
  text-align: center;
  position: relative;
  border-right: 1px solid #bdccd4;
}
.view i {
  position: absolute;
  top: -1px;
}
.view span {
  margin-left: 18px;
}
.zan {
  width: 100px;
  text-align: center;
  position: relative;
  border-right: 1px solid #bdccd4;
}
.zan i {
  position: absolute;
  top: -1px;
}
.zan span {
  margin-left: 18px;
}
.time {
  flex: 1;
  text-align: center;
  position: relative;
}
.time i {
  position: absolute;
  top: -1px;
}
.time span {
  margin-left: 18px;
}
.desc {
  margin: 10px;
  font-size: 14px;
}
.dianzan {
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
  margin-bottom: 10px;
}
.quan {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 2px solid #bdccd4;
  display: flex;
  justify-content: center;
  align-items: center;
}
.quan i {
  font-size: 30px;
}
.zan-tips {
  text-align: center;
  color: #bdccd4;
  margin-bottom: 60px;
}
.footer {
  width: 100%;
  position: fixed;
  bottom: 0px;
  height: 45px;
  display: flex;
}
.footer-item {
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  color: #ffffff;
}
.enter {
  background-color: #fda800;
}
.warn {
  background-color: red;
}
.contact {
  background-color: #179b16;
}
</style>





// WEBPACK FOOTER //
// src/components/infos/CircleDetail.vue